import { service } from "../utils/service";
import { localPath } from "./api.js";

export function succsee() {
  return service({
    url: "/api" + "/demay/ssm/cash/success",
    method: "get",
  });
}

// 查询短信接口
export function getSmsTypePage(params) {
  return service({
    url: "/api" +"/demay/ssm/smsType/pageByState",
    method: "post",
    data: params
  });
}

// 充值短信重发
export function rechargeReissue(data){
  return service({
    url:"/api"+'/demay/ssm/rec/retransmission',
    data,
    method: "post"
  })
}

// 疗程导出
export function exportachis(data){
  return service({
    url:"/api"+'/demay/ssm/course/courseList/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 疗程初始化导出
export function exportachisInit(data){
  return service({
    url:"/api"+'/demay/ssm/course/courseListMemberInit/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 疗程退导出
export function exportRefCourse(data){
  return service({
    url:"/api"+'/demay/ssm/refCourse/refundCash/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 会员协议分页查询
export function memberSelectPage(params) {
  return service({
    url: "/api" + "/demay/ssm/member/selectPage",
    method: "post",
    data: params
  });
}

// 会员协议更新
export function updateMemberAgreement(params) {
  return service({
    url: "/api" + "/demay/ssm/member/updateMemberAgreement",
    method: "post",
    data: params
  });
}

// 会员协议发布
export function pushMemberAgreement(params) {
  return service({
    url: "/api" + "/demay/ssm/member/pushMemberAgreement",
    method: "post",
    data: params
  });
}

// 会员协议新增
export function addMemberAgreement(params) {
  return service({
    url: "/api" + "/demay/ssm/member/addMemberAgreement",
    method: "post",
    data: params
  });
}

// 充值退导出
export function exportRefundRec(data){
  return service({
    url:"/api"+'/demay/refundRec/refundRecharge/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 促销导出
export function exportDocPromotion(data){
  return service({
    url:"/api"+'/demay/ssm/docPromotion/docPromotion/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 消费退导出
export function exportRefundCash(data){
  return service({
    url:"/api"+'/demay/ssm/refCash/refundCash/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 加价转疗程导出
export function exporCardChange(data){
  return service({
    url:"/api"+'/demay/ssm/cardChange/cardChange/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 还款导出
export function exportrepay(data){
  return service({
    url:"/api"+'/demay/ssm/repay/repay/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 充值导出
export function rechargeExport(data){
  return service({
    url:"/api"+'/demay/ssm/rec/rechargeList/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 收银导出
export function exporSyList(data){
  return service({
    url:"/api"+'/demay/ssm/cash/cashList/exportachis',
    data,
    method: "post",
    responseType:'blob'
  })
}

// 疗程短信重发
export function courseReissue(data){
  return service({
    url:"/api" + '/demay/ssm/course/retransmission',
    method: "post",
    data
  })
}

// 更新交易记录充值接口
export function AccountList(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/AccountList",
    method: "post",
    data: params
  });
}

// 收银短信重发
export function sms(data){
  return service({
    url:"/api"+'/demay/ssm/cash/retransmission',
    method: "post",
    data
  })
}

// 门店明细查询 平台端-门店管理-门店审核-门店明细查询
export function storeOne(params) {
  return service({
    url: "/api" + "/demay/ssm/store/one",
    method: "post",
    data: params
  });
}

//预约排队 取号
export function addNumber(params) {
  return service({
    url: "/api" + "/demay/ssm/call/addNumber",
    method: "post",
    data: params
  });
}
//预约排队 叫号
export function callNumber(params) {
  return service({
    url: "/api" + "/demay/ssm/call/callNumber",
    method: "post",
    data: params
  });
}
//预约排队 排队列表
export function callList(params) {
  return service({
    url: "/api" + "/demay/ssm/call/list",
    method: "post",
    data: params
  });
}
//預約排隊 开单
export function addCashList(params) {
  return service({
    url: "/api" + "/demay/ssm/call/addCashList",
    method: "post",
    data: params
  });
}

// 分页查询会员预约列表 (门店端-预约叫号-分页查询会员预约列表)
export function callPage(params) {
  return service({
    url: "/api" + "/demay/ssm/call/page",
    method: "post",
    data: params
  });
}
//
// 查询收银服务单列表 (门店端-服务单-查询收银服务单列表)
export function cashpage(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/page",
    method: "post",
    data: params
  });
}
// 查询收银服务单列表 (门店端-服务单-查询收银服务单列表)
export function cashList(params) {
  return service({
    // url: "/api" + "/demay/ssm/cash/cashList",
    url: "/api" + "/demay/ssm/cash/cashListNew",
    method: "post",
    data: params
  });
}
// 查询收银服务单列表 (门店端-服务单-查询收银服务单列表)
export function cashLists(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/cashLists",
    method: "post",
    data: params
  });
}
// 服务单收银 (门店端-服务单-服务单收银)
export function cashdoCash(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/doCash",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}
// 直接收银 (门店端-服务单-直接收银)
export function addCash(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/addCash",
    // url: "/api" + "/demay/ssm/cash/addCashNew",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}

// 打印查询签名
export function cashsignature(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/signature",
    method: "post",
    data: params
  });
}

// 服务单收银作废 (门店端-服务单-服务单收银作废)
export function cashcancel(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/cancel",
    method: "post",
    data: params
  });
}

// 服务单收银业务人员修改 (门店端-服务单-服务单明细业务人员修改)
export function cashEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/updateStaff",
    method: "post",
    data: params
  });
}

//门店会员添加注册
export function addstoreMember(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/add",
    method: "post",
    data: params
  });
}
// 支付方式查询
export function ctlist(params) {
  return service({
    url: "/api" + "/demay/ssm/ct/list",
    method: "post",
    data: params
  });
}
//充值类别查询
export function recTypeList(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/list",
    method: "post",
    data: params
  });
}
//查询在职员工列表
export function selectList(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/selectList",
    method: "post",
    data: params
  });
}
export function selectListType(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/selectListType",
    method: "post",
    data: params
  });
}

/// 查询单个门店会员
export function storeMemberOne(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/one",
    method: "post",
    data: params
  });
}
// 查询门店用户所拥有的全部充值卡账户
export function recAccountList(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/list",
    method: "post",
    data: params
  });
}
//查询门店用户所拥有的的全部项目疗程
export function couAccountList(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/list",
    method: "post",
    data: params
  });
}
//查询门店用户所拥有的的全部项目疗程
export function couAccountListByJZ(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/listByJZ",
    method: "post",
    data: params
  });
}

//查所以店(只能在会员交易记录使用)
export function listdeal(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/listdeals",
    method: "post",
    data: params
  });
}
//历史(全都都有)
export function listdeals(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/listdealsalls",
    method: "post",
    data: params
  });
}
//历史(只有过期)
export function listdeales(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/delay",
    method: "post",
    data: params
  });
}
//不可用
export function couAccountListDisable(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/listDisable",
    method: "post",
    data: params
  });
}

// 查询门店用户所拥有的会员账户
export function recAccountOne(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/one",
    method: "post",
    data: params
  });
}

//id 查询门店充值类别明细

export function recTypeOne(params) {
  return service({
    url: "/api" + "/demay/ssm/recType/one",
    method: "post",
    data: params
  });
}

// 通过ID查询门店用户所拥有的一个充值账户 (门店端-充值单-通过ID查询所选择充值类别对应会员的充值账户)
export function selectById(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/selectById",
    method: "post",
    data: params
  });
}

// 充值账户修改 (门店端-充值单明细-充值账户修改)
export function editRecAccount(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/update",
    method: "post",
    data: params
  });
}
// 项目明细查询 门店端-项目-项目明细查询
export function proOne(params) {
  return service({
    url: "/api" + "/demay/ssm/pro/one",
    method: "post",
    data: params
  });
}

//添加充值单
export function addrec(params) {
  return service({
    url: "/api" + "/demay/ssm/rec/add",
    method: "post",
    data: params
  });
}
//查询疗程列
export function selectCourseOne(params) {
  return service({
    url: "/api" + "/demay/ssm/course/selectCourseOne",
    method: "post",
    data: params
  });
}

//查询初始疗程列
export function selectCourseOneInit(params) {
  return service({
    url: "/api" + "/demay/ssm/course/selectCourseMemberInit",
    method: "post",
    data: params
  });
}

//查询疗程列
export function selectCourseOneByError(params) {
  return service({
    url: "/api" + "/demay/ssm/course/selectCourseOneByError",
    method: "post",
    data: params
  });
}

//分页查询充值列表
export function recpage(params) {
  return service({
    // url: "/api" + "/demay/ssm/rec/page",
    url: "/api" + "/demay/ssm/rec/pageNew",
    method: "post",
    data: params
  });
}
//充值单作废
export function recCancel(params) {
  return service({
    url: "/api" + "/demay/ssm/rec/cancel",
    method: "post",
    data: params
  });
}

// 充值单业务员修改 (门店端-充值单-充值单业务员修改)
export function recEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/rec/updateStaff",
    method: "post",
    data: params
  });
}

//添加疗程单
// export function addcourse(params) {
//   return service({
//     url: "/api" + "/demay/ssm/course/add",
//     method: "post",
//     data: params
//   });
// }
export function addcourse(params) {
  return service({
    url: "/api" + "/demay/ssm/course/addList",
    method: "post",
    data: params
  });
}

// 疗程初始化
export function addcourseInit(params) {
  return service({
    url: "/api" + "/demay/ssm/course/memberInit",
    method: "post",
    data: params
  });
}
//疗程单列表
export function coursepage(params) {
  return service({
    // url: "/api" + "/demay/ssm/course/page",
    url: "/api" + "/demay/ssm/course/pageNew",
    method: "post",
    data: params
  });
}
// 疗程初始化列表
export function coursepageInit(params) {
  return service({
    url: "/api" + "/demay/ssm/course/memberPage",
    method: "post",
    data: params
  });
}
//疗程单作废
export function coursecancel(params) {
  return service({
    url: "/api" + "/demay/ssm/course/cancel",
    method: "post",
    data: params
  });
}

//初始疗程单作废
export function coursecancelInit(params) {
  return service({
    url: "/api" + "/demay/ssm/course/memberInitCancel",
    method: "post",
    data: params
  });
}

// 单个疗程账户查询 (门店端-单个疗程账户查询)

export function couAccountOne(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/one",
    method: "post",
    data: params
  });
}

// 疗程账户修改 (门店端-疗程单明细-疗程账户修改)
export function editCouAccount(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/update",
    method: "post",
    data: params
  });
}

// 疗程单修改业务员 (门店端-疗程单-疗程单修改业务员)
export function courseEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/course/updateStaff",
    method: "post",
    data: params
  });
}

// 疗程初始单修改业务员 (门店端-疗程单-疗程单修改业务员)
export function courseEditStaffInit(params) {
  return service({
    url: "/api" + "/demay/ssm/course/updateMemberInitStaff",
    method: "post",
    data: params
  });
}

// 欠款单分页查询 门店端-欠款单-欠款单分页查询
export function debtPage(params) {
  return service({
    url: "/api" + "/demay/ssm/debt/page",
    method: "post",
    data: params
  });
}
// 还款单添加 (门店端-还款单-还款单添加)
export function addrepay(params) {
  return service({
    url: "/api" + "/demay/ssm/repay/add",
    method: "post",
    data: params
  });
}
// 还款单作废 (门店端-还款单-还款单作废)
export function repayCancel(params) {
  return service({
    url: "/api" + "/demay/ssm/repay/cancel",
    method: "post",
    data: params
  });
}
// 还款单修改业务员 (门店端-还款单-还款单修改业务员)
export function repayEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/repay/updateStaff",
    method: "post",
    data: params
  });
}

// 分页查询 门店端-还款单-还款页面
export function repayPage(params) {
  return service({
    // url: "/api" + "/demay/ssm/repay/page",
    url: "/api" + "/demay/ssm/repay/pageNew",
    method: "post",
    data: params
  });
}

// 充值退添加 (门店端-充值退-充值退添加)
export function addRefOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/add",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}
// 充值退修改 (门店端-充值退-充值退修改)
export function editRefOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/update",
    method: "post",
    data: params,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
}
// 分页查询 门店端-充值类别-分页查询充值类别
export function refOrderPage(params) {
  return service({
    // url: "/api" + "/demay/ssm/refOrder/page",
    url: "/api" + "/demay/ssm/refOrder/pageNew",
    method: "post",
    data: params
  });
}
// 退款单回收 (门店端-充值退-退款单回收)
export function refOrderRevokeAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/revokeAudit",
    method: "post",
    data: params
  });
}
// 退款单送审 (门店端-充值退-退款单送审)
export function refOrderSendAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/sendAudit",
    method: "post",
    data: params
  });
}
// 分页查询 门店端-充值类别-分页查询充值类别
export function refpage(params) {
  return service({
    url: "/api" + "/demay/refundRec/page",
    method: "post",
    data: params
  });
}

// 充值退账户对应单据查询 (门店端-退款单-充值退账户对应单据查询)
export function recDocList(params) {
  return service({
    url: "/api" + "/demay/refundRec/recDocList",
    method: "post",
    data: params
  });
}
// 充值退账户对应单据查询 (门店端-退款单-充值退账户对应单据查询)
export function refOrderRecDocList(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/recDocList",
    method: "post",
    data: params
  });
}
// 退款单审核 (门店端-退款单-退款单审核)
export function refOrderAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/audit",
    method: "post",
    data: params
  });
}
// 退款单反审核 (门店端-退款单-退款单反审核)
export function refOrderUnAudit(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/unAudit",
    method: "post",
    data: params
  });
}
// 退款单文件下载 (门店端-退款单-退款单文件下载)
export function refOrderDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}
// 疗程退明细查询 门店端-疗程退-疗程退明细查询
export function refCourseList(params) {
  return service({
    url: "/api" + "/demay/ssm/refCourse/list",
    method: "post",
    data: params
  });
}
// 消费退明细查询 门店端-疗程退-消费退明细查询
export function refCashList(params) {
  return service({
    url: "/api" + "/demay/ssm/refCash/list",
    method: "post",
    data: params
  });
}
// 疗程退促销活动项目展示(门店端 - 退款单 - 疗程退促销活动项目展示)
export function refOrderPromotionPro(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/promotionPro",
    method: "post",
    params: params
  });
}

// 校验门店会员收银密码 门店端-门店所有付款页面-校验门店会员收银密码
export function checkCashWord(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/checkCashWord",
    method: "post",
    data: params
  });
}
export function storeMemberedit(params) {
  return service({
    url: "/api" + "/demay/ssm/storeMember/update",
    method: "post",
    data: params
  });
}

// 添加初始化记录 门店端-会员初始化-添加初始化记录
export function memberInitAdd(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/add",
    method: "post",
    data: params
  });
}

// 会员初始化模板下载 门店端-会员初始化-会员初始化模板下载
export function memberInitDownload(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/download",
    method: "post",
    data: params,
    responseType: "blob"
  });
}

// 初始化记录批量导出 门店端-会员初始化-初始化记录批量导出
export function memberInitExport(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/export",
    method: "post",
    data: params,
    responseType: "blob"
  });
}

// 会员初始化记录批量导入 门店端-会员初始化-会员初始化记录批量导入
export function memberInitImport(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/import",
    method: "post",
    data: params
  });
}

// 会员初始化记录修改 (门店端-会员初始化-会员初始化记录修改)
export function memberInitUpdate(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/update",
    method: "post",
    data: params
  });
}

// 会员初始化记录校验 (门店端-会员初始化-会员初始化记录校验)
export function memberInitCheck(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/check",
    method: "post",
    data: params
  });
}
// 会员初始化记录删除 (门店端-会员初始化-会员初始化记录删除)
export function memberInitDelete(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/delete",
    method: "post",
    data: params
  });
}
// 会员初始化账户欠款 (门店端-会员初始化-会员初始化账户欠款)
export function memberInitInit(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/init",
    method: "post",
    data: params
  });
}
// 分页查询初始化记录 门店端-会员初始化-分页查询初始化记录
export function memberInitPage(params) {
  return service({
    url: "/api" + "/demay/ssm/memberInit/page",
    method: "post",
    data: params
  });
}

// 查询门店会员账户交易记录list 会员微信小程序-查询门店会员账户交易记录list
export function listByMember(params) {
  return service({
    url: "/api" + "/demay/ssm/accountTrade/listByMember",
    method: "post",
    data: params
  });
}

// 门店疗程账户修改记录添加 门店端-账户修改记录-门店疗程账户修改记录添加
export function courseAdd(params) {
  return service({
    url: "/api" + "/demay/ssm/modifyAccount/courseAdd",
    method: "post",
    data: params
  });
}
// 疗程账户修改记录分页查询 门店端-账户修改记录-疗程账户修改记录分页查询
export function courseEditPage(params) {
  return service({
    url: "/api" + "/demay/ssm/modifyAccount/coursePage",
    method: "post",
    data: params
  });
}
// 门店充值账户修改记录添加 门店端-账户修改记录-门店充值账户修改记录添加
export function recAdd(params) {
  return service({
    url: "/api" + "/demay/ssm/modifyAccount/recAdd",
    method: "post",
    data: params
  });
}
// 充值账户修改记录分页查询 门店端-账户修改记录-充值账户修改记录分页查询
export function recEditPage(params) {
  return service({
    url: "/api" + "/demay/ssm/modifyAccount/recPage",
    method: "post",
    data: params
  });
}

// 查询门店用户所拥有的全部充值账户
export function recAccountCashList(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/cashList",
    method: "post",
    data: params
  });
}

// 查询门店用户所拥有的全部充值账户
export function cashListByStore(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/cashListByStore",
    method: "post",
    data: params
  });
}

//历史
export function cashListall(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/cashListall",
    method: "post",
    data: params
  });
}

export function cashListalls(params) {
  return service({
    url: "/api" + "/demay/ssm/recAccount/delay",
    method: "post",
    data: params
  });
}

// 疗程退页面疗程账户查询 (门店端-疗程退-疗程退页面疗程账户查询)
export function couAccountRefundList(params) {
  return service({
    url: "/api" + "/demay/ssm/couAccount/refundList",
    method: "post",
    data: params
  });
}

// 分页查询 门店端-充值类别-分页查询充值类别
export function page(params) {
  return service({
    url: "/api" + "/demay/refundRec/page",
    method: "post",
    data: params
  });
}

// 充值退账户对应历史单据查询 金额反算使用 (门店端-退款单-充值退账户对应历史单据查询 金额反算使用)
export function refundRechargeMoney(params) {
  return service({
    url: "/api" + "/demay/refundRec/refundRechargeMoney",
    method: "post",
    data: params
  });
}

// 加价转疗程单据添加 门店端-加价-加价转疗程单据添加
export function addCardChange(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/add",
    method: "post",
    data: params
  });
}

// 加价转疗程单据作废 门店端-加价-加价转疗程单据作废
export function cardChangeCancel(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/cancel",
    method: "post",
    data: params
  });
}

// 加价转疗程转入疗程明细查询 门店端-加价-加价转疗程转入疗程明细查询
export function cardChangeinPro(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/inPro",
    method: "post",
    data: params
  });
}
// 加价转疗程转出疗程明细查询 门店端-加价-加价转疗程转出疗程明细查询
export function cardChangeOutPro(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/outPro",
    method: "post",
    data: params
  });
}

// 加价转疗程分页列表查询 门店端-加价-加价转疗程分页列表查询
export function cardChangePage(params) {
  return service({
    // url: "/api" + "/demay/ssm/cardChange/page",
    url: "/api" + "/demay/ssm/cardChange/pageNew",
    method: "post",
    data: params
  });
}

// 疗程内调
export function cardChangePageLCNT(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/pageNewLCNT",
    method: "post",
    data: params
  });
}

// 加价转疗程单据业务员修改 门店端-加价-加价转疗程单据业务员修改
export function cardChangeEditStaff(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/updateStaff",
    method: "post",
    data: params
  });
}

// 升降级
export function upgrade(params) {
  return service({
    url: "/api" + "/demay/ssm/rec/addUpgrade",
    method: "post",
    data: params
  });
}

// 查询高管列表
export function QuerCompetent(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/QuerCompetent",
    method: "post",
    data: params
  });
}

// 查询门店业绩分类统计表
export function achiCommClassifyList(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/achiCommClassifyList",
    method: "post",
    data: params
  });
}
// 查询门店业绩分类明细
export function achiCommDetailList(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/achiCommDetailList",
    method: "post",
    data: params
  });
}

// 查询门店业绩分类统计表
export function achiCommList(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/achiCommList",
    method: "post",
    data: params
  });
}
// 查询门店元工资
export function salaryByStaff(params) {
  return service({
    url: "/api" + "//demay/ssm/staff/salaryByStaff",
    method: "post",
    data: params
  });
}

//根据单据id类型查询高管  销售单据类型（0=收银单，1=充值单，2=疗程单，3=加价转疗程单，4=充值退款单，5=疗程退款单,6=消费退，7=还款
export function selectOne(params) {
  return service({
    url: "/api" + "/demay/ssm/salesman/selectOne",
    method: "post",
    data: params
  });
}

// 查询门店会员账户交易记录
export function listByMembers(params) {
  return service({
    url: "/api" + "/demay/ssm/accountTrade/listByMembers",
    method: "post",
    data: params
  });
}

// 退款单删除(新添加的)
export function refundDel(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/delete",
    method: "post",
    data: params
  });
}
// 取消欠款条件查询
export function canceSelectById(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/selectById",
    method: "post",
    data: params
  });
}
// 取消欠款添加
export function addCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/add",
    method: "post",
    data: params
  });
}
// 取消欠款修改
export function editCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/update",
    method: "post",
    data: params
  });
}
// 取消欠款列表
export function cancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/page",
    method: "post",
    data: params
  });
}
// 取消欠款审核
export function auditCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/audit",
    method: "post",
    data: params
  });
}
// 取消欠款反审核
export function theauditCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/theaudit",
    method: "post",
    data: params
  });
}
// 取消欠款删除
export function deleteCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/delete",
    method: "post",
    data: params
  });
}
// 取消欠款送审
export function submitCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/submit",
    method: "post",
    data: params
  });
}
// 取消欠款回收
export function recycleCancelDebtList(params) {
  return service({
    url: "/api" + "/demay/ssm/CancelDebtList/recycle",
    method: "post",
    data: params
  });
}

//查询异常单
export function selectAbnormalOrder(params) {
  return service({
    // url: "/api" + "/demay/ssm/staff/selectAbnormalOrder",
    url: "/api" + "/demay/ssm/staff/selectAbnormalOrderNew",
    method: "post",
    data: params
  });
}

// 疗程转充值单添加
export function addRechargeTurnCourse(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeTurnCourse/add",
    method: "post",
    data: params
  });
}

// 查询疗程转充值列表
export function rechargeTurnCoursePage(params) {
  return service({
    // url: "/api" + "/demay/ssm/rechargeTurnCourse/page",
    url: "/api" + "/demay/ssm/rechargeTurnCourse/pageNew",
    method: "post",
    data: params
  });
}

// 疗程转充值单业务员的修改
export function editRechargeTurnCourse(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeTurnCourse/update",
    method: "post",
    data: params
  });
}

// 疗程转充值单反作废
export function rechargeTurnCourseCancel(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeTurnCourse/cancel",
    method: "post",
    data: params
  });
}
// 业绩重算
export function resultsRecalculation(params) {
  return service({
    url: "/api" + "/demay/ssm/staff/ResultsRecalculation",
    method: "post",
    data: params
  });
}

// 充值明细
export function recDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/rec/pageDetail",
    method: "post",
    data: params
  });
}
// 疗程明细
export function proDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/course/pageDetail",
    method: "post",
    data: params
  });
}
// 服务明细
export function cashDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/cash/pageDetail",
    method: "post",
    data: params
  });
}
// 还款单明细
export function repayDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/repay/pageDetail",
    method: "post",
    data: params
  });
}
// 退款单明细
export function refOrderDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/pageDetail",
    method: "post",
    data: params
  });
}
// 加价明细
export function cardChangeDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/pageDetail",
    method: "post",
    data: params
  });
}
// 疗程转充值明细
export function protoDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeTurnCourse/pageDetail",
    method: "post",
    data: params
  });
}

// 促销活动明细
export function promotionDetail(params) {
  return service({
    url: "/api" + "/demay/ssm/docPromotion/pageDetail",
    method: "post",
    data: params
  });
}

// 充值账户内调单添加
export function addRechargeCardTransition(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeCardTransition/add",
    method: "post",
    data: params
  });
}

// 查询会员转卡申请单
export function pageRechargeCardTransition(params) {
  return service({
    // url: "/api" + "/demay/ssm/rechargeCardTransition/page",
    url: "/api" + "/demay/ssm/rechargeCardTransition/pageNew",
    method: "post",
    data: params
  });
}

// 充值账户内调单修改
export function updateRechargeCardTransition(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeCardTransition/update",
    method: "post",
    data: params
  });
}
// 充值账户内调单状态修改
export function updateStateRechargeCardTransition(params) {
  return service({
    url: "/api" + "/demay/ssm/rechargeCardTransition/updateState",
    method: "post",
    data: params
  });
}
// 加价转疗程状态修改
export function updateStateCardChange(params) {
  return service({
    url: "/api" + "/demay/ssm/cardChange/updateState",
    method: "post",
    data: params
  });
}

// 根据会员查询退款
export function getMemberPageNew(params) {
  return service({
    url: "/api" + "/demay/ssm/refOrder/memberPageNew",
    method: "post",
    data: params
  });
}

// 查询签字会员
export function selectAuditMember(params) {
  return service({
    url: "/api" + "/demay/ssm/member/selectAuditMember",
    method: "post",
    data: params
  });
}

export function selectAgreementAndMember(params) {
  return service({
    url: "/api" + "/demay/ssm/member/selectAgreementAndMember",
    method: "post",
    data: params
  });
}

export function cooperateCooper(params) {
  return service({
    url: "/api" + "/demay/ssm/cooperate/cooper",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/eashier.js